import OfficerProfile from "./OfficerProfile";

const OfficersSection = () => {
    return (
        <div className="officers-section">
            <h3 id="officers" className="meet-section-title">Meet the Officers:</h3>
            <div className="officers-grid">
                <OfficerProfile officerImagePath="/images/officers/Kaden.jpg"
                    name="Kaden Culbertson" title="Co-President" />
                <OfficerProfile officerImagePath="/images/officers/Henry.jpg"
                    name="Henry Bloch" title="Co-President" />
                <OfficerProfile officerImagePath="/images/officers/Andrew.jpg"
                    name="Andrew Culbertson" title="Treasurer" />
                <OfficerProfile officerImagePath="/images/officers/Izzie.jpg"
                    name="Izzie Mulita" title="Secretary" />
                <OfficerProfile officerImagePath="/images/officers/Jadyn.jpg"
                    name="Jadyn Smith" title="Webmaster" />
            </div>
        </div>
    );
};

export default OfficersSection;
